import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-group" }
const _hoisted_2 = { class: "list-group-item" }
const _hoisted_3 = { class: "list-group-item" }
const _hoisted_4 = { class: "list-group-item" }
const _hoisted_5 = { class: "list-group-item" }
const _hoisted_6 = { class: "list-group-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, "Ready: " + _toDisplayString(_ctx.cStatistics.ready.length), 1),
    _createElementVNode("li", _hoisted_3, "Error: " + _toDisplayString(_ctx.cStatistics.error.length), 1),
    _createElementVNode("li", _hoisted_4, "Fetching: " + _toDisplayString(_ctx.cStatistics.fetching.length), 1),
    _createElementVNode("li", _hoisted_5, " Deprecated: " + _toDisplayString(_ctx.cStatistics.deprecated.length), 1),
    _createElementVNode("li", _hoisted_6, "Waiting: " + _toDisplayString(_ctx.cStatistics.waiting.length), 1)
  ]))
}